import { ChevronRightOutlinedIcon } from 'tuui';
import { Wizard, WizardStep } from 'taboola-ultimate-ui';
import styleConsts from 'globalStyle/styleConsts.module.scss';
import { FormButtons } from 'modules/campaigns/components';
import { StaticIndications } from 'modules/taboola-common-frontend-modules/Indications';
import { withFormDataProvider } from 'modules/taboola-common-frontend-modules/formData';
import { FormInitBase } from 'modules/taboola-common-frontend-modules/forms';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { SubscriptionInitializeSection } from '../components/SubscriptionInitializeSection/SubscriptionInitializeSection';
import { SubscriptionOutputSection } from '../components/SubscriptionOutputSection/SubscriptionOutputSection';
import { SubscriptionSetupSection } from '../components/SubscriptionSetupSection/SubscriptionSetupSection';
import { pushApiSubscriptionInitialValues } from '../config/initialValues/pushApiSubscriptionInitialValues';
import { useSubscriptionCreatorState } from '../hooks/useSubscriptionCreatorState';
import styles from './pushApiCreatorPage.module.scss';

const wizardTemplateColumns = `${styleConsts.leftPaneWidth}% ${100 - styleConsts.leftPaneWidth}%`;

const PushApiCreatorPage = ({ onCancel }) => {
    const { step, setStep, submit } = useSubscriptionCreatorState();

    return (
        <FormInitBase>
            <Wizard
                wizardContentClassName={styles['wizard-content']}
                step={step}
                onStepChange={setStep}
                wizardTemplateColumns={wizardTemplateColumns}
            >
                <WizardStep
                    label={
                        <FormattedMessage
                            id="push-api.subscription.creator.step.label"
                            defaultMessage="Create Subscription"
                        />
                    }
                    id="setup"
                >
                    <StaticIndications />
                    <div className={styles['form-wrapper']}>
                        <WizardStep
                            label={
                                <FormattedMessage
                                    id="push-api.subscription.creator.step.label"
                                    defaultMessage="Subscription Setup"
                                />
                            }
                            id="subscription-setup"
                        >
                            <SubscriptionInitializeSection />
                        </WizardStep>
                        <WizardStep
                            label={
                                <FormattedMessage
                                    id="push-api.subscription.creator.step.label"
                                    defaultMessage="Subscription Properties"
                                />
                            }
                            id="subscription-properties"
                        >
                            <SubscriptionSetupSection />
                        </WizardStep>
                        <WizardStep
                            label={
                                <FormattedMessage
                                    id="push-api.subscription.creator.step.label"
                                    defaultMessage="Subscription Output"
                                />
                            }
                            id="subscription-output"
                        >
                            <SubscriptionOutputSection />
                            <div className={styles['buttons-wrapper']}>
                                <FormButtons
                                    className={styles['form-buttons']}
                                    onSubmit={submit}
                                    onCancel={onCancel}
                                    submitLabel={<FormattedMessage id="app.actionButtons.create.conversion" />}
                                    submitIcon={<ChevronRightOutlinedIcon />}
                                    submitDataMetricsComponent="NextButton"
                                    cancelLabel={<FormattedMessage id="app.actionButtons.cancel" />}
                                />
                            </div>
                        </WizardStep>
                    </div>
                </WizardStep>
            </Wizard>
        </FormInitBase>
    );
};

const PushApiCreatorPageWithFormDataProvider = withFormDataProvider(PushApiCreatorPage, {
    defaultValuesConfig: pushApiSubscriptionInitialValues,
    formContainerId: Wizard.WIZARD_CONTAINER_ID,
    isNetworkOwnerAllowed: true,
});

export { PushApiCreatorPageWithFormDataProvider as PushApiCreatorPage };
